import React from "react";
import { Text } from "react-native";

export default function Copyright() {
  return (
    <Text className="text-darkergray text-sm m-2">
      ©2024 Izzi Wallet. All rights reserved.
    </Text>
  );
}
